export namespace dataField {
    //分组类型
    export enum RANK_GROUP {
        TT_USER = 'ttUser'
    }

    //操作类型
    export enum OPERA_TYPE {
        COMMIT_SCORE,
        SHOW_SCORE,
    }

    //排行ID
    export enum RANK_ID {
        TRIPLE_JUMP = 'triple',     //三级跳
        JAVELIN = 'javelin',        //标枪
    }

    //排行配置
    export interface RankInterface {
        //操作类型
        operaType: OPERA_TYPE;
        //分组ID
        rankId: RANK_ID;
        //分数
        score?: number;
    }
}